import { HttpParams } from '@angular/common/http';
import { ThisReceiver } from '@angular/compiler';
import { Component, HostListener, OnChanges, OnInit, SimpleChanges, ViewChild,Output,EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { OuterSubscriber } from 'rxjs/internal/OuterSubscriber';
import { ConvalidaFattura } from 'src/app/entities/ConvalidaFattura';
import { DatiAnagraficiRappresentanteFiscale, ModelInvoice } from 'src/app/entities/invoices';
import { UTILS } from 'src/app/entities/Utils';
import { PA, Sezionale, SezionaliProps } from 'src/app/entities/various';
import { ConfigProps, ConfigServiceService } from 'src/app/services/config-service/config-service.service';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { InvoicesService } from 'src/app/services/invoices/invoices.service';
import { LoginService, UserData, UserInfo } from 'src/app/services/login/login.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { UserService } from 'src/app/services/users/user.service';
import { DatiRitenutaCassaScontiComponent } from './dati-ritenuta-cassa-sconti/dati-ritenuta-cassa-sconti.component';
import { ModalServiceService } from 'src/app/services/modal-service/modal-service.service';
import { InvoicesSummaryService } from 'src/app/services/invoicesummary/invoicesummary.service';
import { SessionCountdownService } from 'src/app/services/session-countdown/session-countdown.service';
import { TranslateService } from '@ngx-translate/core';
import { FattureAttiveService } from 'src/app/services/fatture-attive/fatture-attive.service';
import { SharedServiceService } from 'src/app/services/shared/shared-service.service';

@Component({
  selector: 'app-editor-invoice',
  templateUrl: './editor-invoice.component.html',
  styleUrls: ['./editor-invoice.component.css']
})
export class EditorInvoiceComponent implements OnInit {

  @ViewChild('datiRitenutaCassaSconto', { static: false }) datiDoc  : DatiRitenutaCassaScontiComponent | undefined;

  innerWidth: number | undefined = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  navigator: string = 'sidebar.fatture' + ' / ' + 'invoices.addInvoice.new';
  public me: UserInfo | undefined;
  public userInfo: UserData | undefined;
  public modelInvoice : ModelInvoice | undefined;
  public cloneModelInvoice : ModelInvoice | undefined;
  public invoiceRiepilogo : ModelInvoice | undefined;
  public ValidaCedenteCessionarioEvent: Event | any; 
  public aggiornaFakeLineeEvent: Event | any;
  public isLoading : Boolean = true;
  public isSending: Boolean = false;

  private modify : {filename: string, invoice_id: string, new_doc: number} | undefined = undefined;

  params : HttpParams;
  

  configProps: ConfigProps | undefined;
  search: boolean = false;
  loading: boolean = false;
  elencoPA : any;

  eInvoiceFilename: string= "";
  eInvoiceFilenameProg: string = "";

  configInfoFatt = {
    soggetti:{
      btnHiddenContent: false,
      viewContent: true,
      easyMode:true
    },
    dati_documento:{
      btnHiddenContent: false,
      viewContent: true
    },
    documenti_correlati:{
      btnHiddenContent: true,
      viewContent: false
    },
    dati_bene_servizi:{
      btnHiddenContent: false,
      viewContent: true
    },
    dati_trasporto:{
      btnHiddenContent: true,
      viewContent: false
    },
    dati_pagamento:{
      btnHiddenContent: true,
      viewContent: false
    },
    allegati:{
      btnHiddenContent: true,
      viewContent: false
    },
    info_file:{
      btnHiddenContent: true,
      viewContent: false
    }
  }

  selectedSezionale : SezionaliProps | undefined;

  constructor(private invoicesService : InvoicesService, 
              private configService: ConfigServiceService, private configurationService : ConfigurationService,
              private userService: UserService, public toastService: ToastService, public router: Router, 
              private InvoicesSummaryService:InvoicesSummaryService, private modalService : ModalServiceService,
              private sessionCountdownService:SessionCountdownService, private translate: TranslateService,
              private fatturaAttivaService: FattureAttiveService, private loginService: LoginService, private sharedService: SharedServiceService) {
    this.params = new HttpParams();
    this.innerWidth = window.innerWidth;

  }

  modelChange(mI: ModelInvoice): void {
    this.refreshInvoiceFilename();
    
  }

  async ngOnInit(): Promise<void> {
    this.configProps = await this.configService.getJSON();
    
    this.me = JSON.parse(localStorage.getItem("einvuser") || "");
    this.userInfo = await this.loginService.getSessionUserInfo();
    //this.userInfo = JSON.parse(localStorage.getItem("einvuser") || "");
    if(this.userInfo!.fatture_rimanenti <= 0){
      this.toastService.openToastWithConfig(true, 5000, "L'utente non ha abbastanza fatture a disposizione per caricarle. Contattare il proprio amministratore", "warning");
      this.router.navigate(['main/invoices']);
    } else {
      let responseModelsInvoice = await this.invoicesService.getUserInvoiceModel(this.userInfo!.user_id);
      if (responseModelsInvoice.success) {
        this.modelInvoice = responseModelsInvoice.data;
        this.sharedService.setDestinatarioPresente(false);
        
        if (this.modelInvoice!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Denominazione == "") {
          this.modelInvoice!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.PersonaFisica = 1;
        } else {
          this.modelInvoice!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.PersonaFisica = 0;
        }

        // Sistemo la struttura del Rappresentante Fiscale associato al Cessionario Committente
        if(!this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici){
          let objAnagrafica : DatiAnagraficiRappresentanteFiscale = {
            Anagrafica : {
              CodEORI: this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.CodEORI!,
              Cognome: this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Cognome!,
              Denominazione: this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Denominazione!,
              Nome: this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Nome!,
              PersonaFisica: this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.PersonaFisica!,
              Titolo: ""
            },
            CodiceFiscale : "",
            IdFiscaleIVA: this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.IdFiscaleIVA!
          }
  
          this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.CodEORI = null,
          this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Cognome = null;
          this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Denominazione = null,
          this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.IdFiscaleIVA = null;
          this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Nome = null;
          this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.PersonaFisica = null;
          this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici = objAnagrafica;
        }
  
        this.modelInvoice!.FatturaElettronicaHeader.DatiTrasmissione.ProgressivoInvio = this.getRandomName();
        this.modelInvoice!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Divisa = "EUR";
        this.eInvoiceFilenameProg = this.modelInvoice!.FatturaElettronicaHeader.DatiTrasmissione.ProgressivoInvio.substring(0, 5);
        this.refreshInvoiceFilename();
        
        if(localStorage.getItem("einvoice_modify_doc")){
          let resp = await this.invoicesService.downloadInvoiceFiles(this.userInfo!.user_id, localStorage.getItem("einvoice_modify_doc")!, '/download?download=no_signature');
          //let resp = await this.userService.download_no_signature("" + this.userInfo!.user_id, localStorage.getItem("einvoice_modify_doc")!);
          if(resp.success){
            
            this.modify =  {filename: resp.data.file_name, invoice_id: localStorage.getItem("einvoice_modify_doc")!, new_doc: 1};
            //console.log(this.modify);

            var byteCharacters = atob(resp.data.content);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var blob = new Blob([byteArray], {type: resp.data.mime_type});
            await this.compileFromJSON(new File([blob], resp.data.file_name));
            localStorage.removeItem("einvoice_modify_doc");
          }
        } else if (localStorage.getItem("einvoice_duplica_doc")) {
          //let resp = await this.userService.download_no_signature("" + this.userInfo!.user_id, localStorage.getItem("einvoice_duplica_doc")!);
          let resp = await this.fatturaAttivaService.downloadInvoiceFiles(this.userInfo!.user_id, localStorage.getItem("einvoice_duplica_doc")!, '/download?download=no_signature');
          if(resp.success) {
            var byteCharacters = atob(resp.data.content);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var blob = new Blob([byteArray], {type: resp.data.mime_type});
            //console.log(byteCharacters);
            await this.compileFromJSON(new File([blob], resp.data.file_name));
            localStorage.removeItem("einvoice_duplica_doc");
          }
        }

      }
    }

    this.InvoicesSummaryService.setSummaryModel(this.modelInvoice!);
    this.sessionCountdownService.makeSessionAlert.subscribe((drawAlert) => {
      if(drawAlert) {
        this.toastService.openToast("La sessione sta per scadere per inattività.Entro 30 secondi proverò a salvare una bozza.", "warning");
      }
    });

    this.sessionCountdownService.saveInvoiceDraft.subscribe((invoiceDraft) => {
      if(invoiceDraft) {
         this.saveDraft();
      }
    });
    this.isLoading=false;

  }



  public setCodicePA () {
    if (this.modelInvoice!.FatturaElettronicaHeader.DatiTrasmissione.FormatoTrasmissione == 'FPR12') {
        this.modelInvoice!.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = '0000000';
        this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale = '';
    } else {
      this.modelInvoice!.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = '';
    }
  }

  public refreshInvoiceFilename(){
    try {
      var prefissoNomeFile = "";
      var suffissoNomeFile = "";
      if (this.modelInvoice!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese == "") {
          prefissoNomeFile = "IT";
      } else {
          prefissoNomeFile = (this.modelInvoice!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese).toUpperCase();
      }
      if (this.modelInvoice!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdCodice == "") {
          suffissoNomeFile = (this.modelInvoice!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.CodiceFiscale).toUpperCase();
      } else {
          suffissoNomeFile = this.modelInvoice!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdCodice;
      }
      this.eInvoiceFilename = prefissoNomeFile + suffissoNomeFile;
    } catch (e) { }
  }

  public async selectSelezionale(selezionale: SezionaliProps){
    this.selectedSezionale = selezionale;
  }


  public validaCedenteCessionario(input : any){
      this.ValidaCedenteCessionarioEvent=new Event('validaCedenteCessionario');
  }

  public aggiornaFakeLinee(input :any){
    this.aggiornaFakeLineeEvent=new Event('aggiornaFakeLinee');
  }

  public async send(){
    this.isSending = true;
    let convalida : ConvalidaFattura = new ConvalidaFattura(this.getFinalModel());
    let responseConvalida = convalida.addUserInvoice();
    if(responseConvalida.messages.length == 0){
      if(this.modify == undefined){
        let body = {
          data : this.getFinalModel(),
          filename: this.eInvoiceFilename + "_" + this.eInvoiceFilenameProg + ".xml",
          type: "JSON"
        };
        let response = await this.userService.invoices_send("" + this.userInfo!.user_id, body);
        if(response.success){
          await this.saveSelezionale();
          this.toastService.openToast(response.msg, "success");
          this.router.navigate(['main/invoices']);
        } else {
          let allWarning : string = "";
          response.error.forEach((e: string) => {
            allWarning += e + "\n";
          })
          if(allWarning != "") this.toastService.openToastWithConfig(false, 0, allWarning, "warning");
          this.toastService.openToast(response.msg, "error");
          this.isSending = false;
        }
      } else {
        let body = {
          data : this.getFinalModel(),
          filename: this.modify.filename,
          invoice_id: this.modify.invoice_id,
          new_doc: this.modify.new_doc,
          type: "JSON"
        };
        let response = await this.userService.invoices_update("" + this.userInfo!.user_id, body);
        if(response.success){
          //await this.saveSelezionale();
          this.toastService.openToast(response.msg, "success");
          this.router.navigate(['main/invoices']);
        } else {
          let allWarning : string = "";
          response.error.forEach((e: string) => {
            allWarning += e + "\n";
          })
          if(allWarning != "") this.toastService.openToastWithConfig(false, 0, allWarning, "warning");
          this.toastService.openToast(response.msg, "error");
          this.isSending = false;
        }
      }

      
    } else {
      responseConvalida.messages.forEach(m => {
        this.toastService.openToastWithConfig(false, 0,  m.text, m.type);
      });
      this.isSending = false;
    }
  }

  private async saveSelezionale(){
    if(this.selectedSezionale){
      let response = await this.configurationService.getSezionale(this.userInfo!.user_id, this.selectedSezionale.id);
      //console.log(response);
      if(response.success){
        let data : Sezionale = response.data[0];
        data.numerazione = (parseInt("" + data.numerazione) + 1);
        //console.log(data.numerazione);
        await this.configurationService.saveSezionale(this.userInfo!.user_id, data);
      }
    }
  }



  public async downloadXML(){
    let body = {
      data : this.getFinalModel(),
      filename: this.eInvoiceFilename + "_" + this.eInvoiceFilenameProg + ".xml",
      type: "JSON"
    };
    let response = await this.userService.to_xml("" + this.userInfo!.user_id, body);

    if(response.success){
      new UTILS().downloadFile("application/xml", btoa((response.data).normalize('NFD').replace(/[\u0300-\u036f\u0026\u00B0]/g, "")), this.eInvoiceFilename + "_" + this.eInvoiceFilenameProg + ".xml");
    }
  }

  public async saveDraft(){
    let convalida : ConvalidaFattura = new ConvalidaFattura(this.getFinalModel());
    let responseConvalida = convalida.addUserDraft();
    if(responseConvalida.messages.length == 0){

      if (this.modify == undefined) { // se la fattura non proviene da una bozza
        let body = {
          data : this.getFinalModel(true),
          filename: this.eInvoiceFilename + "_" + this.eInvoiceFilenameProg + ".xml",
          type: "JSON"
        };
        let response = await this.userService.draft_invoices("" + this.userInfo!.user_id, body);
        if(response.success){
          this.toastService.openToast("Operazione effettuata con successo!", "success");
          this.router.navigate(['main/invoices']);
        } else {
          let allWarning : string = "";
            response.error.forEach((e: string) => {
              allWarning += e + "\n";
            });
            if(allWarning != "") this.toastService.openToastWithConfig(false, 0, allWarning, "warning");
            this.toastService.openToast(response.msg, "error");
        }
      } else {
        let body = {
          data : this.getFinalModel(),
          filename: this.modify.filename,
          invoice_id: this.modify.invoice_id,
          new_doc: 0,
          type: "JSON"
        };
        let response = await this.userService.invoices_update("" + this.userInfo!.user_id, body);
        if(response.success){
          //await this.saveSelezionale();
          this.toastService.openToast(response.msg, "success");
          this.router.navigate(['main/invoices']);
        } else {
          let allWarning : string = "";
          response.error.forEach((e: string) => {
            allWarning += e + "\n";
          })
          if(allWarning != "") this.toastService.openToastWithConfig(false, 0, allWarning, "warning");
          this.toastService.openToast(response.msg, "error");
        }
      }
      
    } else {
      responseConvalida.messages.forEach(m => {
        this.toastService.openToastWithConfig(false, 0,  m.text, m.type);
      });
    }
  }





  /*
  public async viewPDFMinisteriale(){
    let response = await this.userService.to_xml_pdf("" + this.userInfo!.dms_user_id, this.modelInvoice!);
    if(response.success){
      new UTILS().downloadFile("application/pdf", response.data, response.msg);
    } else {
      this.toastService.openToast(response.msg, "warning");
    }
  }
*/
  /*
  download

  public async viewPDFAssoSoftware(){
    let response = await this.userService.to_xml_pdf_alt("" + this.userInfo!.dms_user_id, this.modelInvoice!);
    if(response.success){
      new UTILS().downloadFile("application/pdf", response.data, response.msg);
    } else {
      this.toastService.openToast(response.msg, "warning");
    }
  }
 */

  public async viewPDFAssoSoftware(){
    let response = await this.userService.to_xml_pdf_alt("" + this.userInfo!.user_id, this.getFinalModel());
    if(response.success){
      let fileUrl = new UTILS().getFileUrl(response.data);
      this.modalService.openPreview(fileUrl, "Anteprima fattura");
    } else {
      this.toastService.openToast(response.msg, "warning");
    }
  }

  public async viewPDFMinisteriale(){
    //let response = await this.userService.to_xml_pdf("" + this.userInfo!.dms_user_id, this.modelInvoice!);
    let response = await this.userService.to_xml_pdf("" + this.userInfo!.user_id, this.getFinalModel());
    if(response.success){
      let fileUrl = new UTILS().getFileUrl(response.data);
      this.modalService.openPreview(fileUrl, "Anteprima fattura");
    } else {
      this.toastService.openToast(response.msg, "warning");
    }
  }


  /**
   * Compilazione da file
   * @param event 
   */


  public async compileFromFile(event: any){
    try {
      let file = (event.target.files as FileList)[0];
      await this.compileFromJSON(file);
    } catch (error) {
      // this.toastConfig = {class:"error", title:await new UTILS().getTranslateTitle(this.translate, 'toast.readFile.error')};
    }
  }


  private async compileFromJSON(file: File){
    let formData = new FormData();
    formData.append('file', file);
    let response = await this.userService.compile_from_xml("" + this.userInfo!.user_id, formData);
      if(response.success){
        let compilerModul : ModelInvoice = response.data;
        if (compilerModul.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Nome != "" &&
            compilerModul.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Cognome != "") {
              compilerModul.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.PersonaFisica = 1;
        } else {
          compilerModul.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.PersonaFisica = 0;
        }
        if (compilerModul.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Nome != "" &&
            compilerModul.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Cognome != "") {
              compilerModul.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.PersonaFisica = 1;
        } else {
          compilerModul.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.PersonaFisica = 0;
        }

        compilerModul.FatturaElettronicaHeader.CedentePrestatore.Sede.Comune = compilerModul.FatturaElettronicaHeader.CedentePrestatore.Sede.Comune.toLocaleUpperCase();
        compilerModul.FatturaElettronicaHeader.CedentePrestatore.Sede.Nazione = compilerModul.FatturaElettronicaHeader.CedentePrestatore.Sede.Nazione.toLocaleUpperCase();
        compilerModul.FatturaElettronicaHeader.CedentePrestatore.Sede.Provincia = compilerModul.FatturaElettronicaHeader.CedentePrestatore.Sede.Provincia.toLocaleUpperCase();
        compilerModul.FatturaElettronicaHeader.CedentePrestatore.Sede.Indirizzo = compilerModul.FatturaElettronicaHeader.CedentePrestatore.Sede.Indirizzo.toLocaleUpperCase();
        compilerModul.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese = compilerModul.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese.toLocaleUpperCase();


        compilerModul.FatturaElettronicaHeader.CessionarioCommittente.Sede.Comune = compilerModul.FatturaElettronicaHeader.CessionarioCommittente.Sede.Comune.toLocaleUpperCase();
        compilerModul.FatturaElettronicaHeader.CessionarioCommittente.Sede.Nazione = compilerModul.FatturaElettronicaHeader.CessionarioCommittente.Sede.Nazione.toLocaleUpperCase();
        compilerModul.FatturaElettronicaHeader.CessionarioCommittente.Sede.Provincia = compilerModul.FatturaElettronicaHeader.CessionarioCommittente.Sede.Provincia.toLocaleUpperCase();
        compilerModul.FatturaElettronicaHeader.CessionarioCommittente.Sede.Indirizzo = compilerModul.FatturaElettronicaHeader.CessionarioCommittente.Sede.Indirizzo.toLocaleUpperCase();
        compilerModul.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese = compilerModul.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese.toLocaleUpperCase();
        compilerModul.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = compilerModul.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario.toLocaleUpperCase();


        // nella compilazione di una fattura a partire da un'altra fattura, la data e il numero non devono essere presenti
        /*try {
          let dt = new Date(compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data as string);
          compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data = {year: dt.getFullYear(), month: dt.getMonth() +1, day: dt.getDate()};
          var ora = Date.now();
          var diffTime = Math.abs(ora - dt.getTimezoneOffset());
          var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if (diffDays > 12) {
              var message = "FATTURE IMMEDIATE!\n\
                              Dal 1 Luglio 2019 sono entrate in vigore le modifiche apportate al DPR 633/72 dal DL 119/2018 e dal Dl 34/2019 (Decreto crescita)\n\
                              Le fatture immediate (XML) hanno un tempo massimo consentito pari a 12 giorni.\n\
                              Questa fattura ha una data che supera i 12 giorni consentiti.\n\
                              Inviandola potrebbe incorrere in sanzioni!\n\
                              \n\
                              Se questa notifica non la riguarda, basta chiuderla semplicemente!";
              // AlertService.addAlert(message, 'warning');
              this.toastService.openToastWithConfig(false, 0, message, "error");
          }
        } catch (error) {
          
        }*/
        let label: string = await new UTILS().getTranslateTitle(this.translate, "modal.labels.confirm");
        let message: string = await new UTILS().getTranslateTitle(this.translate, "modal.messages.mantieni_data_numero");
        let check = await this.modalService.openConfirmBozza(label, message);
        if (check) {
          if (localStorage.getItem("einvoice_duplica_doc")) {
            compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Numero = "";
          } else {
            compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Numero = compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Numero;
          }
          let dt = new Date(compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data as string);
          compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data = {year: dt.getFullYear(), month: dt.getMonth() +1, day: dt.getDate()};
        } else {
          compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data = "";
          compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Numero = "";
        }
        
        for (var i = 0; i < compilerModul.FatturaElettronicaBody.DatiPagamento.length; i++) {
          let dt = new Date(compilerModul.FatturaElettronicaBody.DatiPagamento[i].DettaglioPagamento.DataScadenzaPagamento as string);
          compilerModul.FatturaElettronicaBody.DatiPagamento[i].DettaglioPagamento.DataScadenzaPagamento = {year: dt.getFullYear(), month: dt.getMonth() +1, day: dt.getDate()};
          if (typeof compilerModul.FatturaElettronicaBody.DatiPagamento[i].DettaglioPagamento.DataRiferimentoTerminiPagamento !== "undefined") {
            let dt2 = new Date(compilerModul.FatturaElettronicaBody.DatiPagamento[i].DettaglioPagamento.DataRiferimentoTerminiPagamento as string);
            compilerModul.FatturaElettronicaBody.DatiPagamento[i].DettaglioPagamento.DataRiferimentoTerminiPagamento = {year: dt2.getFullYear(), month: dt2.getMonth() +1, day: dt2.getDate()};
          }          
        }
        for (i = 0; i < compilerModul.FatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto.length; i++) {
          if (typeof compilerModul.FatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto[i].Data !== "undefined") {
            let dt = new Date(compilerModul.FatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto[i].Data as string);
            compilerModul.FatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto[i].Data = {year: dt.getFullYear(), month: dt.getMonth() +1, day: dt.getDate()};
          }
        }
        for (i = 0; i < compilerModul.FatturaElettronicaBody.DatiGenerali.DatiContratto.length; i++) {
          if (typeof compilerModul.FatturaElettronicaBody.DatiGenerali.DatiContratto[i].Data !== "undefined") {
            let dt = new Date(compilerModul.FatturaElettronicaBody.DatiGenerali.DatiContratto[i].Data as string);
            compilerModul.FatturaElettronicaBody.DatiGenerali.DatiContratto[i].Data = {year: dt.getFullYear(), month: dt.getMonth() +1, day: dt.getDate()};
          }
        }
        for (i = 0; i < compilerModul.FatturaElettronicaBody.DatiGenerali.DatiConvenzione.length; i++) {
          if (typeof compilerModul.FatturaElettronicaBody.DatiGenerali.DatiConvenzione[i].Data !== "undefined") {
            let dt = new Date(compilerModul.FatturaElettronicaBody.DatiGenerali.DatiConvenzione[i].Data as string);
            compilerModul.FatturaElettronicaBody.DatiGenerali.DatiConvenzione[i].Data = {year: dt.getFullYear(), month: dt.getMonth() +1, day: dt.getDate()};
          }
        }
        for (i = 0; i < compilerModul.FatturaElettronicaBody.DatiGenerali.DatiRicezione.length; i++) {
          if (typeof compilerModul.FatturaElettronicaBody.DatiGenerali.DatiRicezione[i].Data !== "undefined") {
            let dt = new Date(compilerModul.FatturaElettronicaBody.DatiGenerali.DatiRicezione[i].Data as string);
            compilerModul.FatturaElettronicaBody.DatiGenerali.DatiRicezione[i].Data = {year: dt.getFullYear(), month: dt.getMonth() +1, day: dt.getDate()};
          }
        }
        for (i = 0; i < compilerModul.FatturaElettronicaBody.DatiGenerali.DatiFattureCollegate.length; i++) {
          if (typeof compilerModul.FatturaElettronicaBody.DatiGenerali.DatiFattureCollegate[i].Data !== "undefined") {
            let dt = new Date(compilerModul.FatturaElettronicaBody.DatiGenerali.DatiFattureCollegate[i].Data as string);
            compilerModul.FatturaElettronicaBody.DatiGenerali.DatiFattureCollegate[i].Data = {year: dt.getFullYear(), month: dt.getMonth() +1, day: dt.getDate()};
          }
        }
        for (i = 0; i < compilerModul.FatturaElettronicaBody.DatiGenerali.DatiDDT.length; i++) {
          if (typeof compilerModul.FatturaElettronicaBody.DatiGenerali.DatiDDT[i].DataDDT !== "undefined") {
            let dt = new Date(compilerModul.FatturaElettronicaBody.DatiGenerali.DatiDDT[i].DataDDT as string);
            compilerModul.FatturaElettronicaBody.DatiGenerali.DatiDDT[i].DataDDT = {year: dt.getFullYear(), month: dt.getMonth() +1, day: dt.getDate()};
          }
        }

        //sistemo la formattazione dei valori del dettaglioLinee
        var totaleImponibilePerRitenuta = 0;
        for(i = 0; i < compilerModul.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.length; i++){
          compilerModul.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[i].PrezzoTotale = Number(Number(compilerModul.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[i].PrezzoTotale).toString());
          compilerModul.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[i].PrezzoUnitario = parseFloat(compilerModul.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[i].PrezzoUnitario).toString();
          if (compilerModul.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[i].Ritenuta == 'SI') {
            totaleImponibilePerRitenuta += compilerModul.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[i].PrezzoTotale;
            for (var j = 0; j < compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.length; j++) {
              var calcolo = (totaleImponibilePerRitenuta * parseFloat(compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta[j].AliquotaRitenuta)) / 100;
              if (calcolo != parseFloat(compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta[j].ImportoRitenuta)) {
                compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta[j].PercentualeImponibile = ((parseFloat(compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta[j].ImportoRitenuta) * 100) / calcolo).toString();
              }
            }
          }
          
        }

        // QUESTO SERVE AD ELIMINARE IL CARATTERE & DAI CAMPI CAUSALE
        for (i = 0; i < compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale.length; i++) {
            compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale[i] = (compilerModul.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale[i]).replace('&', ' ');
        }

        let dt = new Date(compilerModul.FatturaElettronicaBody.DatiGenerali.FatturaPrincipale.DataFatturaPrincipale as string);
        compilerModul.FatturaElettronicaBody.DatiGenerali.FatturaPrincipale.DataFatturaPrincipale = {year: dt.getFullYear(), month: dt.getMonth() +1, day: dt.getDate()};

        compilerModul.FatturaElettronicaHeader.DatiTrasmissione.ProgressivoInvio = this.getRandomName();
        this.eInvoiceFilenameProg = compilerModul.FatturaElettronicaHeader.DatiTrasmissione.ProgressivoInvio .substring(0, 5);

        // Sistemo la struttura del Rappresentante Fiscale associato al Cessionario Committente
        if(!compilerModul.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici){
          let objAnagrafica : DatiAnagraficiRappresentanteFiscale = {
            Anagrafica : {
              CodEORI: compilerModul!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.CodEORI!,
              Cognome: compilerModul!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Cognome!,
              Denominazione: compilerModul!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Denominazione!,
              Nome: compilerModul!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Nome!,
              PersonaFisica: compilerModul!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.PersonaFisica!,
              Titolo: ""
            },
            CodiceFiscale : "",
            IdFiscaleIVA: compilerModul!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.IdFiscaleIVA!
          }
  
          compilerModul!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.CodEORI = null,
          compilerModul!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Cognome = null;
          compilerModul!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Denominazione = null,
          compilerModul!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.IdFiscaleIVA = null;
          compilerModul!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Nome = null;
          compilerModul!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.PersonaFisica = null;
          compilerModul!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici = objAnagrafica;
        }

        this.modelInvoice = new UTILS().deepCopy(compilerModul);
        this.refreshInvoiceFilename();
      }
  }

  private getRandomName(): string{
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  async searchPA(val : string) {
    if(val != ""){
      this.loading = true;
      this.elencoPA = (await this.configurationService.getElencoPA(this.userInfo!.user_id, val)).data;
      this.loading = false;
      this.search = true;
    }
  }

  async selectPA(pa: PA){
    //console.log(pa);
    this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Denominazione = (pa.des_amm + " - " + pa.des_ou).substring(0, 80);
    this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.CodiceUnivoco = pa.cod_uni_ou;
    this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale = pa.cf;
    
    this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Indirizzo = pa.indirizzo;
    this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Comune = pa.comune;
    this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.Sede.CAP = pa.cap;
    this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Nazione = 'IT';
    this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Provincia = pa.provincia;
    this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.Sede.NumeroCivico = '';

    if (this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.StabileOrganizzazione != undefined) {
        this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.StabileOrganizzazione = {
          CAP : "",
          Comune: "",
          Indirizzo:"",
          Nazione:"",
          NumeroCivico:"",
          Provincia: ""
        };
    }
    if (this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.IscrizioneREA != undefined) {
        this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.IscrizioneREA.Ufficio = '';
        this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.IscrizioneREA.NumeroREA = '';
        this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.IscrizioneREA.CapitaleSociale = '';
        this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.IscrizioneREA.SocioUnico = '';
        this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.IscrizioneREA.StatoLiquidazione = '';
    }
    if (this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale != undefined) {
        this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.Denominazione = '';
        this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.Cognome = '';
        this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.Nome = '';
        this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.IdFiscaleIVA.IdPaese = '';
        this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.IdFiscaleIVA.IdCodice = '';
        this.modelInvoice!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.CodEORI = '';
    }
    
    this.modelInvoice!.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = pa.cod_uni_ou;

    this.search = false;
  }

  async checkRefreshTotali(){

    this.refreshTotali();
  }

  /**
   * Refresh totali
   */
  async refreshTotali(){
    this.datiDoc!.resetDisabledSconti();
    var totaleFattura : any = 0;
    var totalePagamento : any = 0;
    let invoice = this.modelInvoice!;

    for (var i = 0; i < invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.length; i++) {
        var imponibile: number = parseFloat(this.toFixedCustom(invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].ImponibileImporto, 2));
        var imposta: number = parseFloat(this.toFixedCustom(invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].Imposta, 2));
        totaleFattura += Math.round((imponibile + imposta) * 100) / 100;
        if (invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].EsigibilitaIVA == 'I') {
            totalePagamento = (totaleFattura);
        } else {
            totalePagamento = (parseFloat(totalePagamento) + parseFloat(invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].ImponibileImporto));
        }
    }
    
    var ritenuta = 0;
    if (typeof (invoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta) !== "undefined") {
        for (var i = 0; i < invoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.length; i++) {
            ritenuta += parseFloat(invoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta[i].ImportoRitenuta)
        }
    }

    //devo sottrarre eventuali sconti/maggiorazioni
    var sconti=0;
    if(invoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione.length !=0){
      for(var i=0; i< invoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione.length; i++){
            sconti+=this.calcolaSconto(i);
        }
    }

    if ((invoice.FatturaElettronicaBody.DatiPagamento.length == 0) || (!invoice.FatturaElettronicaBody.DatiPagamento)) {
        invoice.FatturaElettronicaBody.DatiPagamento = [];
        //devo aggiungere altrimenti devo compilare solo la prima riga
        var iban = invoice.FatturaElettronicaHeader.CedentePrestatore.iban;
        invoice.FatturaElettronicaBody.DatiPagamento.push(
          {
            CondizioniPagamento:"TP02", 
            DettaglioPagamento: {
              Beneficiario: "",
              ModalitaPagamento: "MP05",
              DataRiferimentoTerminiPagamento: "",
              GiorniTerminiPagamento: "",
              DataScadenzaPagamento: "",
              ImportoPagamento: "",
              CodUfficioPostale: "",
              CognomeQuietanzante: "",
              NomeQuietanzante: "",
              CFQuietanzante: "",
              TitoloQuietanzante: "",
              IstitutoFinanziario: "",
              IBAN: iban,
              ABI: "",
              CAB: "",
              BIC: "",
              ScontoPagamentoAnticipato: "",
              DataLimitePagamentoAnticipato: "",
              PenalitaPagamentiRitardati: "",
              DataDecorrenzaPenale: "",
              CodicePagamento: ""
            }
          }
        )
        // self.invoicecompiler.addRigaDatiPagamento(invoice);
        invoice.FatturaElettronicaBody.DatiPagamento[0].DettaglioPagamento.ImportoPagamento = (parseFloat(totalePagamento) - ritenuta - sconti).toFixed(2).toString();
        //console.log(invoice.FatturaElettronicaBody.DatiPagamento[0].DettaglioPagamento.ImportoPagamento, "prima volta");
    } else {
        if (invoice.FatturaElettronicaBody.DatiPagamento.length > 0) {
            //devo aggiornare la prima riga
            invoice.FatturaElettronicaBody.DatiPagamento[0].DettaglioPagamento.ImportoPagamento = (parseFloat(totalePagamento) - ritenuta - sconti).toFixed(2).toString();
            //console.log(invoice.FatturaElettronicaBody.DatiPagamento[0].DettaglioPagamento.ImportoPagamento, "nell'if");
        }
    }
    invoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento = "" + (totaleFattura).toFixed(2).toString();
  }

  //aggiorna lo sconto della singola riga e ne restitusce l'importo
  private calcolaSconto(index :number) {

    let row=this.modelInvoice!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione[index];
    var importoTotale = '0';
      if(this.modelInvoice!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[0].EsigibilitaIVA=="S"){
        //l'importo totale è la somma degli imponibili e non il totale fattura.
        for(var i=0;i<this.modelInvoice!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.length;i++)
            importoTotale= "" +(Number.parseFloat(importoTotale)+ Number.parseFloat(this.modelInvoice!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].ImponibileImporto)).toFixed(2);
      }else{
          importoTotale = this.modelInvoice!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento;
      }  
      var tot = 0;
      // Controllo Importo sconto se presente
      if ((+row.Importo > 0) && (+row.Percentuale == 0.00)) {
          if (row.Tipo == "SC")
                  tot = Number.parseFloat(row.Importo);
           else if (row.Tipo == "MG")
                  tot = - (Number.parseFloat(importoTotale) + Number.parseFloat(row.Importo));
      }
      if ((+row.Importo == 0.00) && (+row.Percentuale > 0)) {
          var PrezzoUnitarioCalcolato = 0;
          if (row.Tipo == "SC") 
                  PrezzoUnitarioCalcolato = (Number.parseFloat(importoTotale) * Number.parseFloat(row.Percentuale)) / 100;  
           else if (row.Tipo == "MG") 
                  PrezzoUnitarioCalcolato = - (Number.parseFloat(importoTotale) * Number.parseFloat(row.Percentuale)) / 100;
          tot = (Number.parseFloat("" + PrezzoUnitarioCalcolato));
      }
      return tot;
  }

  public toFixedCustom(value: any, precision: any) {
    var power = Math.pow(10, precision || 1);
    return String(Math.round(value * power) / power);
  }

  async refreshRiepilogo(){
    this.datiDoc!.resetDisabledSconti();
    let invoice = this.modelInvoice!;
    //controllo se esistono note... cioè riga con quantità 0.00, PrezzoUnitario 0.00, Prezzo Totale 0
    //altrimenti cerco di raggruppare l'aliquota iva e la natura su una riga che sia effettivamente un articolo con Prezzo Totale > 0
    let righe = invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee;
    for (var j = 0; j < righe.length; j++) {
        let riga=invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j];
        if(riga.Quantita == '0.00' && riga.PrezzoUnitario == '0.00' && riga.PrezzoTotale == 0){
            //controllo se esiste almeno una altra riga...In tal caso aggiorno l'aliquota iva e la natura della nota.
            let trovato :boolean = false;
            if(invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.length>1){
                for (var i = 0; i < righe.length; i++) {
                  if(i != j) {
                      if(righe[i].Quantita != '0.00' || righe[i].PrezzoUnitario != '0.00' || righe[i].PrezzoTotale != 0){
                        invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j].AliquotaIVA = invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[i].AliquotaIVA;
                        invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j].Natura = invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[i].Natura; 
                        trovato = true;
                      }
                  }
                }
                if (trovato == false) {
                    invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee = [];
                }
            } else {
              invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee = [];
            } 
        }
    }
    // se esiste almeno una linea con scissione dei pagamenti allora tutte devono essere cosi.
       var ScissionePagamenti=false;
        for(var i=0;i<invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.length;i++)
            if(invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].EsigibilitaIVA=="S")
                  ScissionePagamenti=true;

    // invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo = [];
    //controllo se esistono linee di riepilogo da eliminare e nel caso le elimino
    //metto a 0 tutti gli ImponibieImporto
    var count=invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.length-1;
    for(var i=count;i>=0;i--){
      var trovato = false;
      let linea=invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i];
      let BeniServizi=invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee;
      for(var j=0; j<BeniServizi.length;j++){
        invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].ImponibileImporto='0.00';
              if(Number.parseInt(linea.AliquotaIVA)==0){
                    if(BeniServizi[j].Natura==linea.Natura){
                      trovato=true;
                      break;
                    }
              }else{
                  if(Number.parseInt(BeniServizi[j].AliquotaIVA)==Number.parseInt(linea.AliquotaIVA))
                      trovato =true;
                      break;
                }
        }
      if(!trovato)
        invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.splice(i,1);
    }
    

    
    if (invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee) {
        for (var j = 0; j < invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.length; j++) {
              
          if(invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j].AliquotaIVA == ""){
            invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j].AliquotaIVA = "0.00";
          }
          var trovato = false;
          /* GIANPIERO AGGIUNTO IN AND ANCHE IL CONTROLLO SULLA NATURA IN QUANTO SI POSSONO AVERE ALIQUOTE IVA A ZERO PER DIVERSE NATURE */
          for (var i = 0; i < invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.length; i++) {
              if (Number.parseInt(invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].AliquotaIVA) ==
                  Number.parseInt(invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j].AliquotaIVA) &&
                  invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].Natura == invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j].Natura) {
                  //devo sommare alla riga
                  var imponibileImporto = (parseFloat(this.toFixedCustom(invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].ImponibileImporto, 5)) + parseFloat(this.toFixedCustom(invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j].PrezzoTotale, 5)));
                  var imposta = (imponibileImporto * parseFloat(invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j].AliquotaIVA) / 100);
                  invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].ImponibileImporto = this.toFixedCustom(parseFloat("" + imponibileImporto), 5);
                  invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].Imposta = this.toFixedCustom(parseFloat("" + imposta), 5);
                  trovato = true;
                  break;
              }
          }
          if (!trovato) {
            
            var imp = (parseFloat(this.toFixedCustom(invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j].PrezzoTotale, 5)) * parseFloat(invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j].AliquotaIVA)) / 100;
            //devo aggiungere una riga
            let EsigibilitaIVA=ScissionePagamenti?"S":"I";
            invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.push({
                "AliquotaIVA": invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j].AliquotaIVA,
                "Natura": invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j].Natura,
                "SpeseAccessorie": "",
                "Arrotondamento": "",
                "ImponibileImporto": this.toFixedCustom(parseFloat("" + invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[j].PrezzoTotale), 5),
                "Imposta": "" + imp,
                "EsigibilitaIVA": EsigibilitaIVA,
                "RiferimentoNormativo": ""
            });
          }
        }
    }

    //aggiungere i dati della cassa previdenziale
    for (var i = 0; i < invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.length; i++) {
        imponibileImporto = parseFloat(invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].ImponibileImporto);
        imposta = parseFloat(invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].Imposta);
        for (var j = 0; j < invoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.length; j++) {
            if (Number.parseInt(invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].AliquotaIVA) ==
                Number.parseInt(invoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[j].AliquotaIVA) &&
                invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].Natura == invoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[j].Natura) {
                imponibileImporto = imponibileImporto + parseFloat("" + invoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[j].ImportoContributoCassa);
                imposta = (imponibileImporto * parseFloat(invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].AliquotaIVA) / 100);
            }
        }
        invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].ImponibileImporto = "" + parseFloat("" + imponibileImporto);
        invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].Imposta = "" + parseFloat("" + imposta);
    }

    var cassaBool = true;
    for (var k = 0; k < invoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.length; k++) {
        for (var i = 0; i < invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo.length; i++) {
            if (invoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale[k].Natura != invoice.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo[i].Natura) {

                cassaBool = false;
            } else {
                cassaBool = true;
                break;
            }
            if (cassaBool) {
                break;
            }
        }
    }
    if (!cassaBool) {
      this.toastService.openToastWithConfig(false, 0, "Attenzione, in cassa previdenziale è presente un campo Natura diverso da quelli presenti nelle varie linee del Dettaglio Linee", "warning");
    }
    
    this.refreshDatiRitenuta();
    this.refreshDatiCassaPrevidenziale();
    this.refreshTotali();
    //console.log(invoice);
  }

  private refreshDatiCassaPrevidenziale(){
    if(this.modelInvoice!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.length==0)
        return;
    
    let righe=this.modelInvoice?.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee;
        if(righe?.length==0) return;
    let trovato=false;
           righe?.forEach(function(riga) {
                if(riga.AppCassa!=undefined && riga.AppCassa=="SI")
                    trovato=true;
            });
    if(trovato==false)
      {
        this.toastService.openToastWithConfig(false, 0, "Attenzione,la cassa previdenziale è stata rimossa. Non ci sono beni o servizi idonei all'applicazione della cassa.", "warning");
        this.modelInvoice!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.length=0;
      }
    return;  
  }



  private refreshDatiRitenuta(){
    let invoice = this.modelInvoice!;
    let list = invoice.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta;
    let linee=invoice.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee;
    //se esiste almeno una riga di ritenuta, allora deve esistere almeno un dettaglio linee con Ritenuta = SI
    if(list.length > 0 ) {
      let trovato = false;
      for(var i = 0; i< linee.length ; i++) {
        if(linee[i].Ritenuta == 'SI'){
          trovato = true;
          break;
        }
      }
      /*if(!trovato){
        this.modelInvoice!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.length=0;
        this.toastService.openToastWithConfig(false, 0, "Attenzione,la ritenuta è stata rimossa. Non ci sono beni o servizi idonei all'applicazione della ritenuta.", "warning");
      }*/
    }

    for(var i = 0; i < list.length; i++) {
      list[i].ImportoRitenuta = this.calcoloImportoRitenuta((list[i]));
    }
  }


  public calcoloImportoRitenuta(rigaRitenuta : any){
    let datiRiepilogo=this.modelInvoice!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo;
    if(datiRiepilogo?.length==0)
        return "";
    let totale :number=0;
      datiRiepilogo?.forEach(function(riga){
          if(!isNaN(Number(riga.ImponibileImporto)))
            //if((riga.AliquotaIVA !="0.00") && (Number(riga.AliquotaIVA)>0))
                totale+=Number(riga.ImponibileImporto);
      });
      //elimino l'imponibile d eventuali righe con ritenuta = NO
      let linee=this.modelInvoice!.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee;
      for(var i=0; i<linee.length;i++){
        if(/*linee[i].AliquotaIVA !="0.00" && (Number(linee[i].AliquotaIVA)>0) &&*/ linee[i].Ritenuta != 'SI'){
          totale-=Number(linee[i].PrezzoTotale);
        }
      }
    //aggiungo o sottraggo eventuale cassa con ritenuta
    let cassa=this.modelInvoice?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale;
        cassa?.forEach(function(riga){
              if(riga.Ritenuta!='SI')
                  totale-=Number(riga.ImportoContributoCassa);
      });

    if(totale!=0) {
      var totPerc = (totale * rigaRitenuta.PercentualeImponibile) / 100;
      return ((totPerc * rigaRitenuta.AliquotaRitenuta )/100).toFixed(2).toString();
    }
        
    return "";
  }

  private getFinalModel(isDraft? :boolean|undefined){
    let objModel : ModelInvoice = new UTILS().deepCopy(this.modelInvoice!);
    objModel.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data = this.dateToString(this.toDate(objModel.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data as { year: number; month: number; day: number; }));
    //console.log(objModel.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data);
    for (var i = 0; i < objModel.FatturaElettronicaBody.DatiPagamento.length; i++) {
      objModel.FatturaElettronicaBody.DatiPagamento[i].DettaglioPagamento.DataScadenzaPagamento = this.dateToString(this.toDate(objModel.FatturaElettronicaBody.DatiPagamento[i].DettaglioPagamento.DataScadenzaPagamento as { year: number; month: number; day: number; }));
      if (typeof objModel.FatturaElettronicaBody.DatiPagamento[i].DettaglioPagamento.DataRiferimentoTerminiPagamento !== "undefined") {
        objModel.FatturaElettronicaBody.DatiPagamento[i].DettaglioPagamento.DataRiferimentoTerminiPagamento = this.dateToString(this.toDate(objModel.FatturaElettronicaBody.DatiPagamento[i].DettaglioPagamento.DataRiferimentoTerminiPagamento as { year: number; month: number; day: number; }));
      }
    }
    for (i = 0; i < objModel.FatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto.length; i++) {
      objModel.FatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto[i].Data = this.dateToString(this.toDate(objModel.FatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto[i].Data as { year: number; month: number; day: number; }));
    }
    for (i = 0; i < objModel.FatturaElettronicaBody.DatiGenerali.DatiContratto.length; i++) {
      objModel.FatturaElettronicaBody.DatiGenerali.DatiContratto[i].Data = this.dateToString(this.toDate(objModel.FatturaElettronicaBody.DatiGenerali.DatiContratto[i].Data as { year: number; month: number; day: number; }));
    }
    for (i = 0; i < objModel.FatturaElettronicaBody.DatiGenerali.DatiConvenzione.length; i++) {
      objModel.FatturaElettronicaBody.DatiGenerali.DatiConvenzione[i].Data = this.dateToString(this.toDate(objModel.FatturaElettronicaBody.DatiGenerali.DatiConvenzione[i].Data as { year: number; month: number; day: number; }));
    }
    for (i = 0; i < objModel.FatturaElettronicaBody.DatiGenerali.DatiRicezione.length; i++) {
      objModel.FatturaElettronicaBody.DatiGenerali.DatiRicezione[i].Data = this.dateToString(this.toDate(objModel.FatturaElettronicaBody.DatiGenerali.DatiRicezione[i].Data as { year: number; month: number; day: number; }));
    }
    for (i = 0; i < objModel.FatturaElettronicaBody.DatiGenerali.DatiFattureCollegate.length; i++) {
      objModel.FatturaElettronicaBody.DatiGenerali.DatiFattureCollegate[i].Data = this.dateToString(this.toDate(objModel.FatturaElettronicaBody.DatiGenerali.DatiFattureCollegate[i].Data as { year: number; month: number; day: number; }));
    }
    for (i = 0; i < objModel.FatturaElettronicaBody.DatiGenerali.DatiDDT.length; i++) {
      objModel.FatturaElettronicaBody.DatiGenerali.DatiDDT[i].DataDDT = this.dateToString(this.toDate(objModel.FatturaElettronicaBody.DatiGenerali.DatiDDT[i].DataDDT as { year: number; month: number; day: number; }));
    }
    for (i = 0; i < objModel.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.length; i++) {
      for (var j = 0; j < objModel.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[i].AltriDatiGestionali.length; j++) {
        objModel.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[i].AltriDatiGestionali[j].RiferimentoData = this.dateToString(this.toDate(objModel.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[i].AltriDatiGestionali[j].RiferimentoData as { year: number; month: number; day: number; }));
      }
    }
    if (typeof objModel.FatturaElettronicaBody.DatiGenerali.FatturaPrincipale.DataFatturaPrincipale !== "undefined") {
      objModel.FatturaElettronicaBody.DatiGenerali.FatturaPrincipale.DataFatturaPrincipale = this.dateToString(this.toDate(objModel.FatturaElettronicaBody.DatiGenerali.FatturaPrincipale.DataFatturaPrincipale as { year: number; month: number; day: number; }));
    }

    if((isDraft!=undefined ) && (isDraft==true)){
        let count=objModel.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee.length;
        for(var i=0;i<count;i++)
          if(objModel.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[i].AppCassa == undefined)
              objModel.FatturaElettronicaBody.DatiBeniServizi.DettaglioLinee[i].AppCassa = "";
    }

    for (i = 0; i < objModel.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione.length; i++) {
      if (objModel.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione[i].Importo == '0.00') {
        delete (objModel.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione[i] as any).Importo;
      }
      if (objModel.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione[i].Percentuale == '0.00') {
        delete (objModel.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione[i] as any).Percentuale;
      }
    }

    //console.log(objModel);

    return objModel;
  }


  private dateToString(dt: Date){
    let returnVal : string = "";
    try {
      //returnVal = dt.toISOString();
      
      // Creare un oggetto con il fuso orario italiano (CET)
      const timeZoneOffset = 60; // UTC+1 (CET)
      const currentDateItalianTime = new Date(dt.getTime() + timeZoneOffset * 60000);
      
      // Formattare la data in formato ISO
      returnVal = currentDateItalianTime.toISOString();
      
      } catch (error) {}
    return returnVal;
  }

  private toDate(date : {year: number, month: number, day: number}){

    let mese = "";
    let giorno = "";
    mese = (date.month < 10) ? "0" + date.month : "" + (date.month);
    giorno = (date.day < 10) ? "0" + date.day : "" + (date.day);

    var dt = new Date(date.year + "-" + mese + "-" + giorno + " 12:00:00");
    return dt;
  }

}
